import React from 'react';
import { ActivityProvider } from './activity';
import { AppointmentProvider } from './appointment';

import { AuthProvider } from './auth';
import { BookingProvider } from './booking';
import { BookingQueueProvider } from './bookingQueue';
import { CalendarEventProvider } from './calendarEvent';
import { ProductProvider } from './product';
import { SidebarDrawerProvider } from './sidebarDrawer';
import { SpotProvider } from './spot';
import { UserProvider } from './user';
import { VentureProvider } from './venture';

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <SidebarDrawerProvider>
      <VentureProvider>
        <ProductProvider>
          <AppointmentProvider>
            <SpotProvider>
              <ActivityProvider>
                <CalendarEventProvider>
                  <UserProvider>
                    <BookingProvider>
                      <BookingQueueProvider>{children}</BookingQueueProvider>
                    </BookingProvider>
                  </UserProvider>
                </CalendarEventProvider>
              </ActivityProvider>
            </SpotProvider>
          </AppointmentProvider>
        </ProductProvider>
      </VentureProvider>
    </SidebarDrawerProvider>
  </AuthProvider>
);

export default AppProvider;
